<template>
  <section v-if="showContent.length">
    <div
      v-for="(subItem, i) in showContent"
      :key="i"
      class="table">
      <div class="tr style-2">{{subItem.name}}</div>
      <div
        v-for="(item,index) in subItem.content.keys"
        :key="index"
        :class="'style-'+item.type"
        class="tr">
        <span>{{item.name}}{{item.type==4&&isRenew&&subItem.content.is_renew_discount==1?` (${subItem.content[item.key2]*100}%)`:''}}</span>
        <div
          v-if="item.type!=4"
          class="flex flex-algin">
          <span v-if="item.type == 1">
            <el-form-item>
              <v-input
                v-model="subItem.content[item.key]"
                prepend="$"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="changeData" />
            </el-form-item>
          </span>
          <span
            v-if="item.type == 2"
            class="total">
            {{subItem.content[item.key] | formatMoney(2, true)}}
          </span>
          <span
            v-if="item.type == 3">
            <el-form-item>
              <v-input
                v-model="subItem.content[item.key]"
                append="%"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="changeData" />
            </el-form-item>
          </span>
          <span
            v-if="item.type == 3"
            class="right-width">{{subItem.content[item.key2] | formatMoney(2, true)}}</span>
        </div>
        <div v-if="item.type == 4&&isRenew">
          <span
            class="text-right">
            <el-form-item
              prop="spec_disc_prm"
              class="text-right">
              <div
                :class="{
                  'flex-sb': subItem.content.is_renew_discount,
                }">
                <span v-if="subItem.content.is_renew_discount">{{subItem.content[item.key] | formatMoney(2, true)}}</span>
                <div>
                  <span class="mg-r-8">{{subItem.content.is_renew_discount? 'On' : 'Off'}}</span>
                  <el-switch
                    v-model="subItem.content.is_renew_discount"
                    :active-value="1"
                    :inactive-value="0"
                    active-color="#409EFF"
                    inactive-color="#AFB8C1"
                    @change="changeData"></el-switch>
                </div>
              </div>
            </el-form-item>
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MixinFormat from '@/mixins/format'

export default {
  name: 'ExtraBenefitsTable',
  mixins: [MixinFormat],
  props:{
    extra_benefits_content:{
      // formData的选中的extra benefit的内容
      type: Array,
      default: () => []
    },
    selectExtraBenefit:{
      // 选中的extra benefit，从接口返回的内容，因为有时候formData里面有选中但是content没有
      type: Array,
      default: () => []
    },
    extra_benefits:{
      type: Array,
      default: () => []
    },
    isRenew:{
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
      showContent: [],
    }
  },
  watch:{
    selectExtraBenefit:{
      immediate: true,
      deep: true,
      handler(){
        this.setExtraBenefit()
      }
    },
    extra_benefits_content:{
      immediate: true,
      handler(){
        this.setExtraBenefit()
      }
    }
  },
  methods: {
    changeData(){
      this.$emit('changeData')
    },
    setExtraBenefit(){
      // 如果extra_benefits_content里面没有选中的extra benefit就从默认那里添加上去，有多的就去掉
      if(this.selectExtraBenefit && this.selectExtraBenefit.length){
        let contentId = []
        // 先把extra_benefits_content里包含哪些benefit先遍历出来
        this.extra_benefits_content.map(contentItem => {
          contentId.push(contentItem.id)
        })
        let result = false
        this.selectExtraBenefit.map(valItem => {
          if(!contentId.includes(valItem.id)){
            // 如果extra_benefits_content里有漏了的就拿从接口返回的数据补上
            let {is_renew_discount} = valItem.content||{}
            valItem.content.is_renew_discount = is_renew_discount||1
            this.extra_benefits_content.push(valItem)
            result = true
          }
          this.extra_benefits_content.map(contentItem => {
            let {is_renew_discount} = contentItem.content||{}
            contentItem.content.is_renew_discount = is_renew_discount
            contentItem.content.keys = valItem.content.keys
          })
        })
        this.showContent = this.extra_benefits_content.filter(item => {
          return this.extra_benefits.includes(item.id)
        })
        if(result){
          this.changeData()
        }
      }else{
        this.showContent = []
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.table {
  border: 1px solid #E1E4E8;
  border-radius: 8px;
  background-color: #FFFFFF;
  margin-top: 20px;
  .tr {
    height: 64px;
    padding: 0 16px;
    color: #586069;
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
    align-items: center;
    justify-content: space-between;
    &:last-child {
      border-bottom: 0;
    }
    > span {
      flex: 2;
    }
    > div {
      flex: 2
    }
  }
  .tr:nth-child(2n) {
    background: none;
  }
  .tr:first-child{
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .tr:last-child{
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  .style-2 {
    background-color: #F6F8FA !important;
    .span-right {
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 16px;
    }
    .min{
      text-align: center;
      color: #000;
    }
    .total{
      text-align: right;
      color: #000;
    }
  }
  .right {
    text-align: right;
    margin-left: 16px;
  }
  .right-width {
    margin-left: 20px;
    width: 69px;
  }
  .flex-algin {
    align-items: center;
    justify-content: flex-end;
  }
  .mg-r-8{
    margin-right: 8px;
  }
}
</style>
